export default __webpack_public_path__ + "static/media/ic-planner.9fe8acbd.svg";